import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import useScroll from "../../hooks/useScroll";
import logoLanding from "../../assets/logo_landing.svg";
import logoLandingWhite from "../../assets/logo_landing_white.png";
import headerLandingFoto from "../../assets/header_landing_foto.jpg";
import headerLandingFotoDesktop from "../../assets/header_landing_foto_desktop.png";
import useLoginFacade from './useSocialLoginFacade';
import GoogleLogin from 'react-google-login';
import useAuthRedirect from './useAuthRedirect';

const SocialButton = ({ onClick, imgSrc, label }) => (
  <div
    className="flex gap-6 items-center px-4 py-2.5 mt-1.5 w-full border border-white border-solid cursor-pointer"
    onClick={onClick}
  >
    <img loading="lazy" src={imgSrc} className="object-contain shrink-0 w-6 aspect-square" />
    <div className="self-stretch my-auto">{label}</div>
  </div>
);

const InputField = ({ label, placeholder, type = "text", name, value, onChange }) => (
  <div className="flex flex-col w-full">
    <label className="text-xs leading-none text-white mb-1">{label}</label>
    <input
      spellCheck="false"
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="w-full py-1 text-sm leading-none text-white bg-transparent border-b border-white text-opacity-80 focus:outline-none placeholder-white placeholder-opacity-50"
    />
  </div>
);



const ModalLogin = ({ toggleLogin }) => {
  const [type, setType] = useState("loginSocial");
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const { loginWithGoogle, loginWithEmail, clearFormError } = useLoginFacade();
  useAuthRedirect('/');

  const handleEmailLogin = () => {
    clearFormError();
    loginWithEmail(credentials);
  };

  const handleChange = (e) => {
    console.log("handleChange", e.target.name, e.target.value);
    setCredentials(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  return (
    <div className="absolute inset-0 z-[9999] flex justify-end" id="modalLogin">
      <div className="flex flex-col font-medium shadow-md bg-[#7bafcf] w-full md:w-[450px] md:rounded-r-2xl rounded-2xl md:rounded-l-none">
        <div className="flex overflow-hidden flex-col flex-1 px-10 py-9 w-full text-xs text-cyan-950">
          <div className="flex gap-5 items-start w-full text-lg">
            <div className="flex-1 shrink gap-2.5 self-stretch min-w-[240px]">
              Acesse a <span className="font-bold">magikk</span>
            </div>
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/103790acd32d40c0b511bf41726fd638/fcdfeee7578770a76119269f14e22b2ded685ee21950544e4ab7bfa4cbbc093c?apiKey=103790acd32d40c0b511bf41726fd638&"
              className="object-contain shrink-0 w-6 aspect-square cursor-pointer"
              onClick={toggleLogin}
            />
          </div>

          {type !== "loginSocial" && (
            <div
              className="flex gap-5 items-center w-full text-xs font-semibold leading-none min-h-[25px] text-cyan-950 my-3 cursor-pointer"
              onClick={() => setType("loginSocial")}
            >
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/103790acd32d40c0b511bf41726fd638/e5ddea82be82f7b85096ea85234e661a3b573fae75f581a62150bc4990b64dd6?apiKey=103790acd32d40c0b511bf41726fd638&"
                className="object-contain w-[17px]"
              />
              <span>voltar</span>
            </div>
          )}

          {type === "loginSocial" && (
            <div className="flex flex-col mt-5 w-full gap-3">
              <GoogleLogin
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                onSuccess={loginWithGoogle}
                cookiePolicy={"single_host_origin"}
                render={(renderProps) => (
                  <SocialButton
                    onClick={renderProps.onClick}
                    imgSrc="https://cdn.builder.io/api/v1/image/assets/103790acd32d40c0b511bf41726fd638/fcf7a813ddef97a931924bf9ca5941eb9f96057f8b8921c3d74387216f6d732e?apiKey=103790acd32d40c0b511bf41726fd638&"
                    label="Entrar com Google"
                  />
                )}
              />
              <div
                className="flex gap-5 items-center mt-5 w-full font-semibold leading-none text-white cursor-pointer"
                onClick={() => setType("loginEmail")}
              >
                Entrar com email e senha
              </div>
            </div>
          )}

          {type === "loginEmail" && (
            <div className="flex flex-col max-w-[362px]">
              <InputField
                label="Email"
                placeholder="joao@gmail.com"
                name="email"
                onChange={handleChange}
              />
              <InputField
                label="Senha"
                placeholder="••••••••"
                type="password"
                name="password"
                onChange={handleChange}
              />
              <button
                className="mt-5 px-8 py-4 rounded-full bg-[#8dd0e4] text-white hover:bg-[#6ca0b8]"
                onClick={handleEmailLogin}
              >
                Acessar
              </button>
              <div
                className="mt-2 text-xs text-cyan-950 cursor-pointer"
                onClick={() => setType("lostPass")}
              >
                esqueci minha senha
              </div>
            </div>
          )}
        </div>

        <div
          className="flex justify-center items-center py-6 text-base text-white bg-cyan-950 cursor-pointer rounded-b-2xl md:rounded-br-2xl md:rounded-l-none"
          onClick={() => setType(type === "createAccount" ? "loginSocial" : "createAccount")}
        >
          {type === "createAccount" ? "Voltar ao login" : "Não tem uma conta? Cadastre-se"}
        </div>
      </div>
    </div>
  );
};

const NavItem = ({ label, onClick }) => (
  <div
    className="gap-2.5 self-stretch px-3 py-1.5 my-auto border border-blue-400 border-solid rounded-[100px] cursor-pointer"
    onClick={onClick}
  >
    {label}
  </div>
);

const MainButton = ({ label, className, onClick }) => (
  <div
    className={`gap-2.5 self-stretch px-8 py-4 my-auto text-center rounded-[100px] cursor-pointer ${className}`}
    onClick={onClick}
  >
    {label}
  </div>
);


export default function Header() {
  const [showLogin, setShowLogin] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const history = useHistory();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  const toggleLogin = () => setShowLogin(!showLogin);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const scrollToSection = useScroll();

  useEffect(() => {
    window.addEventListener("resize", () => {
      setIsMobile(window.innerWidth < 640);
    });
  }, []);


  return (
    <header className="flex flex-col items-center px-6 md:px-20 pt-8 pb-16 bg-white sm:bg-[#004050] rounded-b-[50px]">

      <div className="flex flex-col w-full max-w-[1146px]">

        <nav className="flex justify-between items-center w-full sm:text-white ">

          <div className="w-[150px]">
            <img
              loading="lazy"
              src={isMobile ? logoLanding : logoLandingWhite}
              className="object-contain w-full cursor-pointer "
              alt="Logo"
              onClick={() => history.push('/')}
            />
          </div>

          <div className="hidden md:flex gap-10 items-center">
            <div className="flex gap-2 items-center text-base">
              <button onClick={() => history.push('/market?category=causes')}>doe</button>
              <div className="w-px bg-white h-[18px]" />
              <button onClick={() => history.push('/market?category=products')}>recompensas</button>
              <div className="w-px bg-white h-[18px]" />
              {/* anchor #platform */}
              <a href="#platform" className="cursor-pointer" onClick={() => scrollToSection("platform")}>karma</a>
            </div>
            {/*<NavItem label="login" onClick={toggleLogin} />*/}
            <NavItem label="login" onClick={() => history.push('/login')} />
          </div>


          <div className="md:hidden bg-[#004050] border border-white border-solid rounded-[10px] px-1">
            <button
              onClick={toggleMenu}
              className="text-white text-2xl focus:outline-none"
            >
              ☰
            </button>
          </div>

        </nav>

        <div className="md:hidden flex flex-col items-start mt-8 text-[#004150] text-3xl w-5/12">
          Recompensamos boas ações
        </div>

        {isMenuOpen && (
          <div className="flex flex-col gap-4 mt-4  md:hidden text-white sm:bg-transparent bg-[#004050] rounded-b-[20px] px-4 py-2">
            <span>doe</span>
            <span>recompensas</span>
            <span>karma</span>
            {/*<NavItem label="login" onClick={toggleLogin} />*/}
            <NavItem label="login" onClick={() => history.push('/login')} />
          </div>
        )}

        <div className="flex flex-col mt-16 bg-opacity-30 rounded-3xl  sm:bg-transparent ">
          <div className="relative min-h-[300px] sm:min-h-[400px] md:min-h-[429px] rounded-3xl bg-[#004050]">
            <img
              loading="lazy"
              src={isMobile ? headerLandingFoto : headerLandingFotoDesktop}
              className="absolute inset-0 object-cover w-full h-full rounded-3xl opacity-20 sm:opacity-100"
              alt="Background"
            />
            {showLogin && <ModalLogin toggleLogin={toggleLogin} />}


            <div className="flex flex-col items-center justify-center px-6 py-16 sm:px-12 sm:py-20 md:px-20 md:py-28 bg-opacity-70 relative">
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-8 sm:leading-9 md:leading-10 text-center text-white">
                Participe de experiências <br />
                de impacto gamificadas e <br />
                acumule recompensas.
              </h1>
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 items-center mt-8">
                <MainButton
                  label="Quero fazer o bem"
                  className="bg-[#8CCFEE] text-white"
                  // onClick={toggleLogin}
                  onClick={() => history.push('/login')}
                />
                <MainButton
                  label="Sou uma empresa"
                  className="bg-white text-blue-400 border border-white shadow-[0px_4px_4px_rgba(0,0,0,0.1)]"
                  onClick={() => history.push('/company-form')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

